<template>
  <div class="list-end" role="status">
    <i class="fa-solid fa-check" aria-hidden="true" />
    <span>没有更多了</span>
  </div>
</template>

<style scoped>
.list-end {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
  padding: 16px 0;
  color: var(--text-soft);
  font-size: 13px;
}
</style>
